import { useProject } from '../../contexts/ProjectContext';
import { useUIState } from '../../contexts/UIStateContext';
import { NotificationDropdown } from '../notifications/NotificationDropdown';
import { useCopy } from '../../i18n';
import MobileScreen from './MobileScreen';

interface AvisosScreenProps {
  onSair: () => void;
}

/**
 * Notificações como destino próprio, e não como sino escondido no cabeçalho.
 *
 * No celular o sino perde: ele é um alvo de 20px competindo com o título da
 * tela, e o que ele guarda é justamente o que traz a pessoa de volta ao app.
 * Como destino da barra, ele ganha alvo de toque inteiro e um lugar previsível.
 *
 * A lista em si é o `NotificationDropdown` que já existe e já funciona, com
 * realtime e marcação de lida. Reimplementar uma segunda lista de notificações
 * criaria dois lugares para consertar o mesmo bug; aqui ele só troca de moldura,
 * saindo do popover e ocupando a tela.
 */
const AvisosScreen = ({ onSair }: AvisosScreenProps) => {
  const t = useCopy().common.mobileTabs;
  const { switchProject, focusTask } = useProject();
  const { changeModule } = useUIState();

  return (
    // `semPadding`: a lista de notificacao e full-bleed de proposito, com o
    // divisor indo de borda a borda. Cartao com margem aqui competiria com o
    // avatar de quem gerou o aviso.
    <MobileScreen titulo={t.notificacoes} semPadding>
      <NotificationDropdown
        fullWidth
        onNavigateToTask={(projectId, taskId) => {
          // Clicar no aviso leva ao Quadro, que é a tela de execução do celular.
          // O Gantt seria o destino natural no desktop e é justamente o que não
          // existe aqui.
          //
          // `focusTask` recebe projeto E tarefa: ele guarda o alvo para destacar
          // quando o projeto terminar de carregar, e sem o projeto não saberia
          // em qual lista procurar.
          focusTask(projectId, taskId);
          switchProject(projectId);
          changeModule('kanban');
          onSair();
        }}
        onClose={onSair}
      />
    </MobileScreen>
  );
};

export default AvisosScreen;
